export class Slideshow {
    constructor(element, images) {
        this.element = element;
        this.images = images;
        this.currentIndex = 0;
        this.slides = [];

        // Get configuration from data attributes
        this.slideDuration = parseInt(element.dataset.slideDuration) || 6000;
        this.transitionDuration = parseInt(element.dataset.transitionDuration) || 1500;

        this.init();
    }

    createSlides() {
        this.images.forEach((src) => {
            const slide = document.createElement('div');
            slide.className = 'hero-background';
            slide.innerHTML = `<img src="${src}" alt="Hero background image">`;
            this.element.insertBefore(slide, this.element.firstChild);
            this.slides.push(slide);
        });
    }

    showSlide(index) {
        // Remove active and zoom classes from all slides
        this.slides.forEach(slide => {
            slide.classList.remove('active', 'zoom');
        });

        // Add active class to current slide
        this.slides[index].classList.add('active');

        // Add zoom effect after a short delay
        setTimeout(() => {
            this.slides[index].classList.add('zoom');
        }, 100);
    }

    nextSlide() {
        this.currentIndex = (this.currentIndex + 1) % this.slides.length;
        this.showSlide(this.currentIndex);
    }

    init() {
        this.createSlides();
        this.showSlide(0);

        // Start automatic slideshow
        setInterval(() => this.nextSlide(), this.slideDuration);
    }
}
